import { styled } from "styled-components";

const Container = styled.div`
  position: relative;

  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  padding: 1rem 1.5rem;
  flex-grow: 1;
  z-index: 10;
  > button {
    max-width: 115px;
    & > svg {
      flex-shrink: 0;
      transform: rotate(225deg);
      fill: ${({ theme }) => theme.colors.white};
    }
  }
`;

const TotalScoreContainer = styled.div`
  border-radius: 1.5rem;
  border: 1px solid #2c3034;
  background: #f5e8ed;
  box-shadow: 4px 4px 0px 0px #2c3034;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1.5rem;

  > img:first-of-type {
    width: 2.25rem;
    height: 2.25rem;
    margin-bottom: 0.75rem;
  }
`;

const Title = styled.h1`
  text-align: center;
  color: ${({ theme }) => theme.colors.black};
  font-family: ${({ theme }) => theme.fonts.grotesk};

  font-size: 1.75rem;
  font-style: normal;
  font-weight: 900;
  line-height: 100%;
  margin-bottom: 0.75rem;
  margin-left: 10px;
  margin-right: 10px;
`;

const SubTitle = styled.h2`
  color: ${({ theme }) => theme.colors.secondaryText};

  text-align: center;
  font-family: ${({ theme }) => theme.fonts.inter};

  font-size: 0.875rem;
  font-style: normal;
  font-weight: 600;
  line-height: 140%;
  margin-bottom: 0.75rem;
`;
const LearnMore = styled.span`
  color: ${({ theme }) => theme.colors.inform};
  text-align: center;
  font-family: ${({ theme }) => theme.fonts.inter};

  font-size: 0.875rem;
  font-style: normal;
  font-weight: 600;
  line-height: 140%;
  margin-bottom: 0.75rem;
`;

const ComingSoon = styled.span`
  flex: 1;
  color: ${({ theme }) => theme.colors.pink};

  text-stroke: 1px black;
  -webkit-text-stroke: 1px black;

  font-family: ${({ theme }) => theme.fonts.grotesk};
  font-variant-numeric: lining-nums tabular-nums;
  font-feature-settings: "dlig" on;
  text-shadow: 2px 2px 0px ${({ theme }) => theme.colors.black};
  -webkit-text-stroke-width: 1.5px;
  -webkit-text-stroke-color: ${({ theme }) => theme.colors.black};
  font-size: 2.5rem;
  font-style: normal;
  font-weight: 800;
  line-height: 116%;

  & > span {
    color: #7b766d;
    font-family: ${({ theme }) => theme.fonts.grotesk};

    -webkit-text-stroke-width: 0;
    -webkit-text-stroke-color: #7b766d;
    font-size: 2.5rem;
    font-style: normal;
    font-weight: 800;
    line-height: 116%;
    text-shadow: none;
  }
`;

const ClaimedContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0.5rem;
  width: 100%;

  border-radius: 0.5rem;
  background-color: ${({ theme }) => theme.colors.surfaceQuaternary};

  & > div {
    display: flex;
    justify-content: space-between;
    & > p {
      color: ${({ theme }) => theme.colors.black};
      font-size: 0.75rem;
      font-style: normal;
      font-weight: 600;
      line-height: 140%;
    }
  }
`;

const Progress = styled.progress`
  width: 100%;
  -webkit-appearance: none;
  appearance: none;
  border: none;
  border-radius: 1.5rem;
  background: ${({ theme }) => theme.colors.airdrop.progressBarBg};
  &::-moz-progress-bar {
    background: ${({ theme }) => theme.colors.airdrop.progressBarValue};
    border-radius: 1.5rem;
    border: 1px solid ${({ theme }) => theme.colors.black};
    transition: width 1s ease;
  }
  &::-webkit-progress-value {
    background: ${({ theme }) => theme.colors.airdrop.progressBarValue};
    border-radius: 1.5rem;
    border: 1px solid ${({ theme }) => theme.colors.black};
    transition: width 1s ease;
  }
  &::-webkit-progress-bar {
    background: transparent;
    border-radius: 1.5rem;
  }

  &:not([value]) {
    &::-moz-progress-bar {
      display: none;
    }
    &::-webkit-progress-value {
      display: none;
    }
  }
`;

const YourTrustScore = styled.span`
  color: ${({ theme }) => theme.colors.secondaryText};
  text-align: center;
  font-family: ${({ theme }) => theme.fonts.inter};
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 600;
  line-height: 140%;
  margin-top: 1.5rem;
`;

const TotalTrustScoreValue = styled.span`
  color: ${({ theme }) => theme.colors.orangeSecondary};

  font-variant-numeric: lining-nums tabular-nums;
  font-feature-settings: "dlig" on;
  text-shadow: 2px 2px 0px ${({ theme }) => theme.colors.black};

  text-stroke: 1px black;
  -webkit-text-stroke: 1px black;
  -webkit-text-stroke-width: 1.5px;
  -webkit-text-stroke-color: ${({ theme }) => theme.colors.black};
  font-family: ${({ theme }) => theme.fonts.grotesk};
  font-size: 3.25rem;
  font-style: normal;
  font-weight: 900;
  line-height: 116%;
`;

const Scores = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  width: 100%;
  margin-bottom: 1.5rem;
`;

const Networks = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  padding: 0.5rem 0.5rem;

  border-radius: 1rem;
  background: ${({ theme }) => theme.colors.surfaceScores};
`;

const Network = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
  padding: 0 0.5rem;

  & > svg {
    width: 1.5rem;
    height: 1.5rem;
  }
`;

const Header = styled.div<{ $isOpen: boolean }>`
  cursor: pointer;

  display: flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0 0.5rem;

  & > p {
    flex: 1;
    color: ${({ theme }) => theme.colors.black};
    font-size: 0.875rem;
    font-weight: 700;
  }

  & > svg {
    transform: rotate(${({ $isOpen }) => ($isOpen ? 270 : 90)}deg);
    transition: transform 300ms;
  }
`;

const Text = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

  & > p {
    &:last-of-type {
      color: ${({ theme }) => theme.colors.greyOp05};
      font-size: 0.75rem;
      font-weight: 500;
      line-height: 120%;
      letter-spacing: -0.015rem;
    }

    &:first-of-type {
      color: ${({ theme }) => theme.colors.black};
      font-family: ${({ theme }) => theme.fonts.manrope};
      font-size: 0.875rem;
      font-weight: 700;
      line-height: 1.25rem;
    }
  }
`;

const ScoreAmount = styled.div`
  width: 4.125rem;
  text-align: right;
  & > span {
    line-height: 140%;
    color: ${({ theme }) => theme.colors.black};
    font-weight: 700;
    font-size: 1rem;

    &:last-of-type {
      opacity: 0.5;
    }
  }
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  margin-top: 0.5rem;

  & > p {
    color: ${({ theme }) => theme.colors.secondaryText};
    font-size: 0.75rem;
    font-weight: 600;
    line-height: 140%;
    padding: 0 0.5rem;
  }
`;

const SuccessBox = styled.div`
  display: flex;
  gap: 0.5rem;
  justify-items: center;
  align-items: center;
  flex-direction: row;
  margin: 1.5rem 0 0.5rem;
  & > span {
    color: #009393;
    font-family: ${({ theme }) => theme.fonts.inter};
    font-size: 1rem;
    font-style: normal;
    font-weight: 600;
    line-height: 140%;
  }
`;

const ClaimedPoints = styled.span`
  color: ${({ theme }) => theme.colors.black};
  text-align: center;
  font-family: ${({ theme }) => theme.fonts.grotesk};
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 900;
  line-height: normal;
`;

const ClaimedValue = styled.span`
  color: #3fe1ff;
  font-variant-numeric: lining-nums tabular-nums;
  font-feature-settings: "dlig" on;
  text-shadow: 2px 2px 0px ${({ theme }) => theme.colors.black};

  text-stroke: 1px black;
  -webkit-text-stroke-width: 1.5px;
  -webkit-text-stroke-color: ${({ theme }) => theme.colors.black};

  font-family: ${({ theme }) => theme.fonts.grotesk};
  font-size: 3.25rem;
  font-style: normal;
  font-weight: 900;
  line-height: 116%;
  margin: 1.2rem 0;
`;

const ClaimedDescription = styled.p`
  color: ${({ theme }) => theme.colors.secondaryText};
  text-align: center;
  font-family: ${({ theme }) => theme.fonts.inter};

  font-size: 0.875rem;
  font-style: normal;
  font-weight: 600;
  line-height: 140%;
  margin-bottom: 0.75rem;
`;

const CheckContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25rem;

  font-size: 0.75rem;
  font-weight: 600;
  line-height: 120%;

  svg {
    width: 1.2rem;
    height: 1.2rem;
  }
`;

const BazookaLogo = styled.img`
  width: 148px;
  height: auto;
  margin-top: 1.5rem;
`;

const NoTrustScoreContainer = styled.div`
  display: flex;
  padding: 1rem;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.75rem;
  align-self: stretch;
  border-radius: 1rem;
  border: 2px dashed #beb3a9;
  margin-top: 1rem;
`;
const NoTrustScoreTitle = styled.span`
  color: ${({ theme }) => theme.colors.black};
  text-align: center;
  font-family: ${({ theme }) => theme.fonts.inter};
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;
const NoTrustScoreSubtitle = styled.span`
  color: ${({ theme }) => theme.colors.secondaryText};
  text-align: center;
  font-family: ${({ theme }) => theme.fonts.inter};
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 600;
  line-height: 140%; /* 1.225rem */
`;

export default {
  Container,
  Header,
  TotalScoreContainer,
  Title,
  SubTitle,
  LearnMore,
  ComingSoon,
  ClaimedContainer,
  Progress,
  YourTrustScore,
  TotalTrustScoreValue,
  Scores,
  Networks,
  Network,
  Text,
  ScoreAmount,
  Body,
  SuccessBox,
  ClaimedPoints,
  ClaimedValue,
  ClaimedDescription,
  CheckContainer,
  BazookaLogo,
  NoTrustScoreContainer,
  NoTrustScoreTitle,
  NoTrustScoreSubtitle,
};
